import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { awardTypeOptions } from '@/module/Nomen/AwardType/model/AwardTypeModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type AwardTypeSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function AwardTypeSelectControl<T extends FieldValues>(props: AwardTypeSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(awardTypeOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
